export default "__VITE_ASSET__K6gjCU4I__";